import { createSlice } from '@reduxjs/toolkit';

export const sharedSlice = createSlice({
    name: 'shared',
    initialState: {
      reportingABug: false,
      loadingMetadata: false,
      avatarUploadLoading: false,
      userLoadingError: false,
      insuranceOptions: [],
      insuranceOptionsLoading: false,
      insuranceOptionsLoadingError: false,
      specialtyOptions: [],
      personModalOpen: false,
      loadingAppState: false,
      skeletonScreenOpen: false,
      tabIndex: "0",
      snackbarOpen: false,
      snackbarMessage: "",
    },
    reducers: {
      setReportingABug: (state, action) => {
        state.reportingABug = action.payload;
      },
      setLoadingMetadata: (state, action) => {
        state.loadingMetadata = action.payload;
      },
      setAvatarUploadLoading: (state, action) => {
        state.avatarUploadLoading = action.payload;
      },
      setUserLoadingError: (state, action) => {
        state.userLoadingError = action.payload;
      },
      setInsuranceOptions: (state, action) => {
        state.insuranceOptions = action.payload;
      },
      setInsuranceOptionsLoading: (state, action) => {
        state.insuranceOptionsLoading = action.payload;
      },
      setInsuranceOptionsLoadingError: (state, action) => {
        state.insuranceOptionsLoadingError = action.payload;
      },
      setSpecialtyOptions: (state, action) => {
        state.specialtyOptions = action.payload;
      },
      setPersonModalOpen: (state, action) => {
        state.personModalOpen = action.payload;
      },
      setLoadingAppState: (state, action) => {
        state.loadingAppState = action.payload;
      },
      setSkeletonScreenOpen: (state, action) => {
        state.skeletonScreenOpen = action.payload;
      },
      setTabIndex: (state, action) => {
        state.tabIndex = action.payload;
      },
      setSnackbarOpen: (state, action) => {
        state.snackbarOpen = action.payload;
      },
      setSnackbarMessage: (state, action) => {
        state.snackbarMessage = action.payload;
      },
    }
  });

export const {
    setReportingABug,
    setLoadingMetadata,
    setAvatarUploadLoading,
    setUserLoadingError,
    setInsuranceOptions,
    setInsuranceOptionsLoading,
    setInsuranceOptionsLoadingError,
    setSpecialtyOptions,
    setPersonModalOpen,
    setLoadingAppState,
    setSkeletonScreenOpen,
    setTabIndex,
    setSnackbarOpen,
    setSnackbarMessage,
} = sharedSlice.actions;

export default sharedSlice.reducer;